import React from "react";
import { KeyboardShortcuts } from "react-piano";
import WebMidi from "webmidi";
// Component
import MidiNumbers from "pianoGithub/MidiNumbers";
import Piano from "pianoGithub/Piano";
import { keyboardV2 } from "utils/Data";
import { areEqual } from "utils/Function";

class PianoShort extends React.Component {
  state = {
    keyPress: this.props.keyPress || [],
  };
  FIRST_NOTE = MidiNumbers.fromNote("c2");
  LAST_NOTE = MidiNumbers.fromNote("B6");

  keyboardShortcuts = KeyboardShortcuts.create({
    firstNote: this.FIRST_NOTE,
    lastNote: this.LAST_NOTE,
    keyboardConfig: keyboardV2,
  });

  componentDidUpdate() {
    const { activeNote, buildChords } = this.props;

    if (areEqual(activeNote, this.state.keyPress)) {
      buildChords();
    }
    console.log(WebMidi);

    WebMidi.enable((error) => {
      if (error) {
        alert("WebMidi could not be enabled.");
        return;
      }
      alert("WebMidi enabled.");
      if (WebMidi.inputs.length === 0) {
        alert("No MIDI inputs.");
        return;
      }
      const input = WebMidi.inputs[0];
      input.addListener("noteon", "all", (event) => {
        this.handlePlayNoteInput(event.note.number);
      });
      input.addListener("noteoff", "all", (event) => {
        this.handleStopNoteInput(event.note.number);
      });
    });
  }

  handleMidiEvent(midiNumber, eventType) {
    this.setState((prevState) => {
      const { keyPress } = prevState;

      if (eventType === "start") {
        if (keyPress.includes(midiNumber)) {
          return null;
        }
        return {
          ...prevState,
          keyPress: keyPress.concat(midiNumber),
        };
      } else if (eventType === "stop") {
        return {
          ...prevState,
          keyPress: keyPress.filter((note) => midiNumber !== note),
        };
      }
    });
  }

  handlePlayNoteInput(midiNumber) {
    this.handleMidiEvent(midiNumber, "start");
  }

  handleStopNoteInput(midiNumber) {
    this.handleMidiEvent(midiNumber, "stop");
  }

  render() {
    const { hide, activeNote, translateNote, nameKeyChord } = this.props;
    let indice = 0;
    return (
      // <div style={{ pointerEvents: "none" }}>
      <Piano
        noteRange={{
          first: this.FIRST_NOTE,
          last: this.LAST_NOTE,
        }}
        playNote={(midiNumber) => {
          // console.log(midiNumber);
        }}
        stopNote={(midiNumber) => {
          // console.log(midiNumber);
        }}
        renderNoteLabel={({
          keyboardShortcut,
          midiNumber,
          isActive,
          isAccidental,
        }) => {
          if (
            !hide &&
            nameKeyChord.length > 0 &&
            activeNote.includes(midiNumber)
          ) {
            return (
              <div>
                <p
                  style={{
                    color: "white",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  {translateNote(nameKeyChord[indice++ % 3])}
                </p>
              </div>
            );
          }
        }}
        activeNotes={this.state.keyPress}
        chordsToPlay={!hide ? activeNote : []}
        keyWidthToHeight={0.21}
        keyboardShortcuts={this.keyboardShortcuts}
      />
      // </div>
    );
  }
}

export default PianoShort;
